import React from 'react'

import Button from 'components/Form/Button'

import { StateDescription, StateRoot, StateTitle } from './styled'

export default function CatalogState({ actionLabel, description, onAction, title }) {
  return (
    <StateRoot role={onAction ? 'alert' : 'status'}>
      <StateTitle>{title}</StateTitle>
      {!description ? null : <StateDescription>{description}</StateDescription>}
      {!onAction ? null : (
        <Button color="blue" nospace width="fit-content" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </StateRoot>
  )
}
